import React, { lazy, Suspense, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Redirect, Route, useHistory } from "react-router-dom";
import { userActions } from "../actions";
import { NotificationManager } from "react-notifications";
import MemberLayout from "./MemberLayout";

export const routes = [
    {
        path: "/member/logon",
        exact: true,
        component: lazy(() => import("../pages/MemLogin/Memlogin")),
        // component: lazy(() => (
        //     <div>
        //         {(() => {
        //             alert("ปิดเพื่อพัฒนาระบบชั่วคราว");
        //             window.location.href = "/home";
        //         })()}
        //     </div>
        // )),
    },
    {
        path: "/member/registerauth",
        exact: true,
        component: lazy(() => import("../pages/Memregis/UserAuthMain")),
    },
    {
        path: "/member/termofconditional",
        exact: true,
        // component: lazy(() => import("../pages/Memregis/Memregis"))
        component: lazy(() => import("../pages/Memregis/termOfConditional")),
    },
    {
        path: "/member/register",
        exact: true,
        // component: lazy(() => import("../pages/Memregis/Memregis"))
        component: lazy(() => import("../pages/Memregis/UserAuthMain")),
    },
    {
        path: "/member/forget",
        exact: true,
        // component: lazy(() => import("../pages/Memregis/Memregis"))
        component: lazy(() => import("../pages/Memregis/UserAuthMain")),
    },
    {
        path: "/member/impersonate",
        exact: true,
        component: lazy(() => import("../pages/MemImpersonate/MemInpersonate")),
    },
    {
        path: "/member/status",
        exact: true,
        auth: true,
        layout: "member",
        component: lazy(() => import("../pages/MemStatus/Memstatus")),
    },
    {
        path: "/member/share",
        exact: true,
        auth: true,
        layout: "member",
        component: lazy(() => import("../pages/MemShare/MemShare")),
    },
    {
        path: "/member/loan",
        exact: true,
        auth: true,
        layout: "member",
        component: lazy(() => import("../pages/MemLoan/MemLoan")),
    },
    {
        path: "/member/loan_statement/:statement",
        exact: true,
        auth: true,
        layout: "member",
        component: lazy(() => import("../pages/MemLoan/MemLoanStatement")),
    },
    {
        path: "/member/deposit",
        exact: true,
        auth: true,
        layout: "member",
        component: lazy(() => import("../pages/Memdep/Memdep")),
    },
    {
        path: "/member/dep_statement/:statement",
        exact: true,
        auth: true,
        layout: "member",
        component: lazy(() => import("../pages/Memdep/MemdepStatement")),
    },
    {
        path: "/member/kep",
        exact: true,
        auth: true,
        layout: "member",
        component: lazy(() => import("../pages/Memkep/Memkep")),
    },
    {
        path: "/member/kepcrem",
        exact: true,
        auth: true,
        layout: "member",
        component: lazy(() => import("../pages/MemkepCrem/MemkepCrem")),
    },
    {
        path: "/member/coll",
        exact: true,
        auth: true,
        layout: "member",
        component: lazy(() => import("../pages/MemColl/MemColl")),
    },
    {
        path: "/member/gian",
        exact: true,
        auth: true,
        layout: "member",
        component: lazy(() => import("../pages/MemGian/Memgian")),
    },
    {
        path: "/member/welfare",
        exact: true,
        auth: true,
        layout: "member",
        component: lazy(() => import("../pages/MemWelfare/MemWelfare")),
    },
    {
        path: "/member/dividend",
        exact: true,
        auth: true,
        layout: "member",
        component: lazy(() => import("../pages/MemDiv/Memdiv")),
    },
    {
        path: "/member/requestpromoney",
        exact: true,
        auth: true,
        layout: "member",
        component: lazy(() => import("../pages/MemRequestPromoney/MemRequestPromoney")),
    },
    // {
    //     path: "/member/insurance",
    //     exact: true,
    //     auth: true,
    //     layout: "member",
    //     component: lazy(() => import("../pages/Meminsurance/Meminsurance")),
    // },
    {
        path: "/member/password",
        exact: true,
        auth: true,
        layout: "member",
        component: lazy(() => import("../pages/MemPass/Mempass")),
    },
    {
        path: "/member/confirmData",
        exact: true,
        auth: true,
        layout: "member",
        component: lazy(() => import("../pages/MemConfirmData/MemConfirmData")),
    },
    // {
    //     path: "/member/*",
    //     exact: true,
    //     component: lazy(() => import("../pages/MemLogin/Memlogin")),
    // },
    // {
    //     path: "/member/welcome",
    //     exact: true,
    //     auth: true,
    //     component: lazy(() => import("../pages/MemWelcome/Welcome")),
    // },
    // {
    //     path: "/member/test",
    //     exact: true,
    //     auth: false,
    //     component: lazy(() => import("../pages/Dialog/DialogOtpForm"))
    // }
];

const MemberRoute = ({ component: Component, ...rest }) => {
    const isAuthenticated = useSelector(
        (state) => state.authentication.loggedIn
    );

    const dispatch = useDispatch();
    const history = useHistory();

    useEffect(() => {
        if (isAuthenticated) {
            // console.log("Helloodebugerrrr");
            dispatch(userActions.getAuthUser()).catch((errors) => {
                // NotificationManager.error(err.data.error, "Error", 5000);
                NotificationManager.error(errors.data.error, "Error", 5000);
                // console.log("HelloodebugerrrrErrormama");
                history.push("/member/logon");
            });
        }
    }, [dispatch, isAuthenticated]);

    return (
        <Route
            {...rest}
            render={(props) => {
                if (!isAuthenticated) return <Redirect to="/member/logon" />;

                return (
                    <Suspense fallback={<> </>}>
                        {/* <ScrollToTop /> */}
                        <MemberLayout>
                            <Component {...props} />
                        </MemberLayout>
                    </Suspense>
                );
            }}
        />
    );
};

export default MemberRoute;
